import React, { useState, useEffect } from 'react'
import BackgroundImage from './BackgroundImage'
import PaypalButton from './PaypalButton'
import { Typography, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

function MembershipIFrame() {
  return (
    <div style={{ width: "100%", maxWidth: 640 }}>
      <iframe
        id="membership-i-frame"
        src="https://docs.google.com/forms/d/e/1FAIpQLSfn7gXa4BieZrIMQOOH5auwDQ9AOVFn1jfrWMS3B0DKP2rhrg/viewform?embedded=true"
        style={{ width: "100%", border: 0 }}
        height="1600" frameBorder="0" marginHeight="0" marginWidth="0">Loading…</iframe>
    </div>
  )
}

export default function GetInvolvedPage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <div className='faded-background' style={{
      "--b": `url(${require('../assets/GetInvolved.jpg')})`,
      display: "flex",
      flexDirection: "column",
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: isMobile ? 12 : 0,
      paddingRight: isMobile ? 12 : 0,
      gap: 20,
      alignItems: "center",
      boxSizing: "border-box"
    }}>
      <PaypalButton />
      <MembershipIFrame/>
    </div>
  )
}